import { FormStatus } from '@atlassian/proforma-common-core/form-system-models';
import { getLastViewedForm } from './utils';

/**
 * Returns a default selectedFormId in the FormIndexStore.
 * If there is a lastViewFormCookie, it uses that to determine the form ID.
 * Otherwise, it returns the first open form.
 */
export const getDefaultFormId = (formIndex, projectId) => {
  var _formIndexItem;
  // if there is a cookie with a templateFormId, then expand the first form on the issue which has a matching
  // templateFormId. If there is no matching form, then don’t expand any form in the issue view
  let formIndexItem;
  const lastViewedTemplateForm = projectId && getLastViewedForm(projectId);

  // if there's a previous template form ID saved in a cookie
  if (lastViewedTemplateForm) {
    // find the first matching form with that templateFormId
    formIndexItem = formIndex.find(issueIndexForm => issueIndexForm.projectFormId === lastViewedTemplateForm.templateFormId);
  } else {
    // If there is no cookie, show the first open form on the issue.
    formIndexItem = formIndex.find(item => item.status === FormStatus.Open);
  }
  return (_formIndexItem = formIndexItem) === null || _formIndexItem === void 0 ? void 0 : _formIndexItem.id;
};